import { render } from "./Icon.vue?vue&type=template&id=1ce40bb8&ts=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__